import { IoJournal } from "react-icons/io5"
import { useNavigate } from "react-router-dom";
import styles from "./styles.module.css"

export default function BookReadButton({ bookId }) {

    const navigate = useNavigate();

    function readBook() {
        navigate("/reader/" + bookId, { replace: true })
    }


    return (
        <button title="Ler e-book" onClick={() => { readBook() }} className={styles.readButton}>
            <IoJournal />
        </button>
    );
}